export const GET_SUPPORT_REQUESTS = `
  query GetSupportRequests {
    sonnenEinstellungen {
      textSettings {
        support {
          headline
          descriptionCategories
        }
      }
    }
    supportRequests {
      description
      link
      title
      slug
      iconSrc
      iconAltText
    }
  }
`;
